import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-background p-8">
      <div className="max-w-3xl mx-auto">
        <Link to="/">
          <Button variant="ghost" className="mb-6 gap-2">
            <ArrowLeft className="w-4 h-4" />
            Retour
          </Button>
        </Link>
        
        <h1 className="text-3xl font-bold mb-6">Conditions d'Utilisation</h1>
        
        <div className="prose prose-slate max-w-none space-y-4">
          <p><strong>Dernière mise à jour :</strong> {new Date().toLocaleDateString('fr-FR')}</p>
          
          <h2 className="text-xl font-semibold mt-6">1. Acceptation des conditions</h2>
          <p>
            En utilisant SocialHub, vous acceptez ces conditions d'utilisation. Si vous n'êtes pas d'accord, 
            veuillez ne pas utiliser le service.
          </p>
          
          <h2 className="text-xl font-semibold mt-6">2. Description du service</h2>
          <p>
            SocialHub est un outil de gestion de réseaux sociaux qui vous permet de :
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Créer et publier du contenu sur plusieurs plateformes</li>
            <li>Planifier des publications</li>
            <li>Gérer l'historique de vos publications</li>
          </ul>
          
          <h2 className="text-xl font-semibold mt-6">3. Responsabilités de l'utilisateur</h2>
          <p>
            Vous êtes responsable de :
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Respecter les conditions d'utilisation de chaque réseau social</li>
            <li>Ne pas publier de contenu illégal ou offensant</li>
            <li>Protéger vos identifiants de connexion</li>
          </ul>
          
          <h2 className="text-xl font-semibold mt-6">4. Propriété intellectuelle</h2>
          <p>
            Vous conservez tous les droits sur le contenu que vous créez et publiez via SocialHub.
          </p>
          
          <h2 className="text-xl font-semibold mt-6">5. Limitation de responsabilité</h2>
          <p>
            SocialHub n'est pas responsable des actions prises par les plateformes de réseaux sociaux 
            concernant votre compte ou votre contenu.
          </p>
          
          <h2 className="text-xl font-semibold mt-6">6. Modifications</h2>
          <p>
            Nous nous réservons le droit de modifier ces conditions à tout moment. Les modifications 
            seront effectives dès leur publication.
          </p>
        </div>
      </div>
    </div>
  );
}
